function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.612 14.333h86v143.334h-86Z",
    style: {
      fill: "#c5c5c5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.778 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Z",
    style: {
      fill: "#9e9e9e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.695 25.083a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.503 74.646) scale(.55556)",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vka)",
    d: "M50.167 57.333h-21.5c-3.942 0-7.167-3.225-7.167-7.166v-21.5c0-3.942 3.225-7.167 7.167-7.167h21.5c3.941 0 7.166 3.225 7.166 7.167v21.5c0 3.941-3.225 7.166-7.166 7.166z",
    style: {
      fill: "#023c3c",
      fillOpacity: 1,
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkb)",
    d: "M143.333 57.333h-21.5c-3.941 0-7.166-3.225-7.166-7.166v-21.5c0-3.942 3.225-7.167 7.166-7.167h21.5c3.942 0 7.167 3.225 7.167 7.167v21.5c0 3.941-3.225 7.166-7.167 7.166z",
    style: {
      fill: "#023c3c",
      fillOpacity: 1,
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkc)",
    d: "M50.167 150.5h-21.5c-3.942 0-7.167-3.225-7.167-7.167v-21.5c0-3.941 3.225-7.166 7.167-7.166h21.5c3.941 0 7.166 3.225 7.166 7.166v21.5c0 3.942-3.225 7.167-7.166 7.167z",
    style: {
      fill: "#023c3c",
      fillOpacity: 1,
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkd)",
    d: "M143.333 150.5h-21.5c-3.941 0-7.166-3.225-7.166-7.167v-21.5c0-3.941 3.225-7.166 7.166-7.166h21.5c3.942 0 7.167 3.225 7.167 7.166v21.5c0 3.942-3.225 7.167-7.167 7.167z",
    style: {
      fill: "#023c3c",
      fillOpacity: 1,
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.833,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.167,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.833,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.167,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 107.5,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 93.167,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 78.833,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 64.5,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 107.5,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 93.167,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 78.833,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 64.5,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    style: {
      strokeWidth: 3.58333
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineServer);
export default __webpack_public_path__ + "static/media/engineServer.d6a69f2dd2800d83c76edb5f6fc191ba.svg";
export { ForwardRef as ReactComponent };